export const ADD_ACTIONS_TO_STASH = 'ADD_ACTIONS_TO_STASH';
export const CLEAR_STASH = 'CLEAR_STASH';
